import { Button, Typography } from "@mui/material";
import { useLoaderData } from "react-router-dom";
import {
  AddCircleOutline,
  RadioButtonUnchecked,
  TaskAlt,
} from "@mui/icons-material";
import AddProvider from "./AddProvider";
import { useState } from "react";

const Providers = ({ data, label }) => {
  const { providersClient } = useLoaderData();
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <div className="flex flex-wrap w-full gap-4">
        {/* Question */}
        <div className="flex items-center justify-between w-full mb-2">
          <Typography fontWeight="medium">{label}</Typography>
          {/* Actions */}
          <div className="">
            <Button
              className="py-2 pl-8 pr-2 text-xs text-indigo-700 normal-case bg-white border-indigo-700 hover:border-indigo-700 w-52 rounded-3xl"
              variant="outlined"
              onClick={() => setOpenModal(true)}
            >
              Add Provider{" "}
              <AddCircleOutline fontSize="small" className="ml-auto" />
            </Button>
          </div>
        </div>

        {/* Providers */}
        <div className="flex flex-wrap w-full gap-3">
          {providersClient.map((provider) => {
            const providerTypes = (
              provider?.provider?.providerTypes.map((type) => type.name) || []
            ).join(", ");
            return (
              <div
                className="flex items-center w-full gap-2 p-6 rounded-lg bg-sky-100"
                key={provider?.id}
              >
                <TaskAlt className="text-blue-700" />
                <p className="text-sm line-clamp-1">
                  <b>{provider?.provider?.name}</b> -{" "}
                  {provider.provider.inNetwork
                    ? "In Network"
                    : "Out of Network"}{" "}
                  <span className="text-xs text-gray-400">
                    ({providerTypes})
                  </span>
                </p>
                {/* TODO: Validate status */}
                <RadioButtonUnchecked className="ml-auto text-sm text-blue-700" />
              </div>
            );
          })}
        </div>
      </div>
      {openModal && <AddProvider setOpenModal={setOpenModal} />}
    </>
  );
};

export default Providers;
